<template>
  <div class="quest-intro">
    <div class="quest-intro__content">
      <div
        v-if="introImageUrl"
        class="quest-intro__image">
        <img :src="introImageUrl" :alt="questName" width="100%" height="auto" />
      </div>

      <div class="quest-intro__header">
        <h1 class="quest-intro__title">{{ questName }}</h1>
      </div>

      <div class="quest-intro__body">
        <div
          class="quest-intro__message"
          v-html="formattedIntro" />
      </div>

      <div class="quest-intro__actions">
        <button
          class="btn btn--fat"
          @click="handleStart">
          Start Quest
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import sharedStore from "components/quest/shared-store";

export default {
  name: "QuestIntro",
  data() {
    return {
      sharedStore
    }
  },
  props: {
    questName: {
      type: String,
      default: ""
    },
    intro: {
      type: String,
      default: ""
    },
    introImageUrl: {
      type: String,
      default: null
    }
  },
  computed: {
    formattedIntro() {
      const username = this.sharedStore.state.username;
      return this.intro.replaceAll("%username%", username);
    }
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeydown);
  },
  methods: {
    handleKeydown(event) {
      if ((event.metaKey || event.ctrlKey) && event.key === "Enter") {
        event.preventDefault();
        event.stopPropagation();

        this.sharedStore.nextScreen();
      }
    },
    handleStart() {
      this.sharedStore.nextScreen();
    }
  },
  mounted() {
    this.sharedStore.startChapter();

    document.addEventListener("keydown", this.handleKeydown);
  }
}
</script>

<style lang="scss" scoped>
.quest-intro {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: $px48 0;

  &__content {
    max-width: 600px;
    width: 100%;
  }

  &__title {
    margin-bottom: $px32;

    @include h1;
  }

  &__message {
    margin-bottom: $px48;

    @include font-regular;
  }

  &__image {
    max-width: 600px;
    width: 100%;
    margin-bottom: $px32;

    img {
      display: block;
      max-width: 100%;
      height: auto;

      border-radius: $px8;
    }
  }

  &__actions {
    display: flex;
    justify-content: center;
    gap: $px16;
  }
}
</style>
